import { render, staticRenderFns } from "./versionFilmRecordByXML.vue?vue&type=template&id=1c3d6098&scoped=true&"
import script from "./versionFilmRecordByXML.vue?vue&type=script&lang=js&"
export * from "./versionFilmRecordByXML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d6098",
  null
  
)

export default component.exports